import { Link } from "react-router-dom";
import { getToshiType, viewPath } from "../../utils/routeUtils";
import { parseJsonLike, prettify } from "../../utils/prettifyJson";
import { ReactNode } from "react";

/**
 * A component that is rendered either as string or as a link if the string happens to be an id.
 * @param value
 * @returns
 */
export const maybeLink = (value: string) => {
  if (getToshiType(value)) {
    return <Link to={viewPath(value)}>{value}</Link>;
  }
  return value;
};

const collectStrings = (data: ReactNode[]) => {
  const result = [];
  let collect = [];
  for (const element of data) {
    if (typeof element === "string") {
      collect.push(element);
    } else {
      result.push(collect.join(""));
      collect = [];
      result.push(element);
    }
  }
  if (collect.length > 0) {
    result.push(collect.join(""));
  }
  return result;
};

export interface PrettJsonProps {
  json: string | null | undefined;
}

export const PrettyJson: React.FC<PrettJsonProps> = ({ json }: PrettJsonProps) => {
  if (json === null || json === undefined) {
    return "";
  }

  if (json.startsWith("{") || json.startsWith("[")) {
    const parsed = parseJsonLike(json);
    if (parsed) {
      const pretty = prettify(parsed);
      // see if strings (between " characters) can be turned into links
      const withLinks = collectStrings(pretty.split(/(")/).map((value) => maybeLink(value)));
      if (json.startsWith("{")) {
        return (
          <pre style={{ overflowX: "auto", marginTop: "0px", marginBottom: "0px", fontSize: "0.875rem" }}>
            {withLinks}
          </pre>
        );
      }
      // Arrays will look better without the `pre` tag. Assumption: there are no maps in arrays.
      return withLinks;
    }
  }
  return maybeLink(json);
};
